import React from "react";
import { string } from "prop-types";

import Anchor from "../Anchor";

import "./excerpt.m.css";

const Excerpt = ({ excerpt = "", url = "" }) => {
  if (!excerpt) return null;

  return (
    <Anchor aria-label={excerpt} href={url} styleName="excerpt" className="excerpt">
      {excerpt}
    </Anchor>
  );
};

Excerpt.propTypes = {
  excerpt: string,
  url: string,
};

export default Excerpt;
